import * as React from "react"
import { connect } from "react-redux"
import { toastr } from "react-redux-toastr"

import { Route } from "react-router"
import { Switch, withRouter } from "react-router-dom"
import { Button } from "semantic-ui-react"
import { isPropertySignature } from "typescript"
import { DropitState, getUserRole } from "../../../core/reducers"
import { $myFetch } from "../../../core/requests"
import { Roles } from "../../../utils"

import Home from "../../containers/con_home"
import ProductForm from "../../product-form"
import ProductList from "../../product-list"
import NotFoundPage from "../com_not-found-page"

const Body = () => (
  <div className="body-container">
    <Switch>
      <Route exact path="/" component={Home} />
      <Route path="/product_list" component={ProductList} />
      <Route
        exact
        path="/product_form/:id/:declinedid"
        component={ProductForm}
      />
      <Route exact path="/product_form/:id" component={ProductForm} />
      <Route exact path="/revalidate" component={Revalidator} />
      <Route path="*" component={NotFoundPage} />
    </Switch>
  </div>
)

export default Body

const RevalidatorComponent = (props: { role: Roles }) => {
  if (props.role === Roles.MARKET_LEADER) {
    return (
      <Button onClick={$revalidateEveryProducts}>
        Revalider TOUS les produits (déjà validés) de dropit
      </Button>
    )
  } else {
    return <></>
  }
}

const mapStateToProps = (state: DropitState, ownProps: any) => ({
  role: getUserRole(state),
})

const mapDispatchToProps = (dispatch: any) => ({})

const Revalidator = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(RevalidatorComponent)
)

const $revalidateEveryProducts = () => {
  const myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")
  toastr.message("En cours de traitement", "", {
    component: (
      <>
        <p>
          Cette requête peut être longue: l'action va s'éxécuter en tâche de
          fond.
        </p>
        <p>
          Si vous restez sur Drop'it vous serez notifié lorsqu'elle sera
          terminée.
        </p>
      </>
    ),
  })
  return $myFetch(
    "product/revalidateAllProducts",
    {
      body: "{}",
      headers: myHeaders,
      method: "POST",
    },
    []
  ).then((res) => {
    toastr.removeByType("message")
    toastr.info("Les produits ont été validés !", "", {
      showCloseButton: true,
      timeOut: 25000,
    })
    return res
  })
}
